import { createContext } from 'react';
const DEFAULT_CONFIG = { hideDescriptionOverlays: false };
// eslint-disable-next-line react/only-export-components -- The provider and consumers share this module-scoped context.
export const SourcesMenuConfigContext = createContext(DEFAULT_CONFIG);
SourcesMenuConfigContext.displayName = 'SourcesMenuConfigContext';
export const SourcesMenuConfigProvider = SourcesMenuConfigContext.Provider;
//# sourceMappingURL=SourcesMenuConfigContext.js.map